import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  name: string;
  _type: string;
  risk_level: "low" | "medium" | "high";
  active: boolean;
  order: 1;
}
export const useCreateSector = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.post(
      `${env.verifyServiceUrl}individual/business_sector_risk_level/`,
      params,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
